export default (value) => {
  // 千分位過濾
  if(value!==null && value!==undefined){
    const intPart = value.toString().split('.');
    intPart[0] = intPart[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return intPart.join('.');
  }
};
